export const ALLOWED_GZ_HOST_SUFFIXES = ['gazzetta.it', 'stg.occloud.io'] as const;
export const ALLOWED_GZ_EXACT_HOSTS = ['localhost'] as const;

export function isAllowedGazzettaOrigin(origin: string): boolean {
  try {
    const hostname = new URL(origin).hostname;
    return (
      ALLOWED_GZ_EXACT_HOSTS.some(h => hostname === h) ||
      ALLOWED_GZ_HOST_SUFFIXES.some(s => hostname === s || hostname.endsWith(`.${s}`))
    );
  } catch {
    return false;
  }
}
